<template>
    <transition name="fade">
        <div class="columns is-multiline" v-if="subscriptions">
            <div
                class="column is-half-tablet is-one-third-widescreen"
                v-for="subscription in subscriptions"
                :key="subscription.id"
            >
                <subscription :subscription="subscription"></subscription>
            </div>
        </div>
    </transition>
</template>

<script>
import Subscription from './Subscription';
import ApiClient from '../support/ApiClient';

export default {
    name: 'Subscriptions',

    compontents: { Subscription },

    data: () => ({
        subscriptions: [],
        api: {}
    }),

    mounted() {
        this.api = new ApiClient('store');
        this.setSubscriptions();
    },

    methods: {
        setSubscriptions() {
            this.api.get('subscriptions', data => {
                this.subscriptions = data;
            });
        }
    }
}
</script>
